import React from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const CourseCardSkeleton = React.memo(() => {
  return (
    <Card className="h-full flex flex-col overflow-hidden">
      {/* Image Skeleton */}
      <Skeleton className="h-48 w-full rounded-none" />
      
      {/* Content Skeleton */}
      <div className="p-5 space-y-4 flex-1 flex flex-col justify-between min-h-[180px]">
        <div className="space-y-3">
          {/* Badge Skeleton */}
          <Skeleton className="h-5 w-16" />
          
          {/* Title Skeleton */}
          <div className="space-y-2">
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-3/4" />
          </div>
        </div>
        
        <div className="space-y-3">
          {/* Metadata Skeleton */}
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-24" />
          </div>
          
          {/* Progress Bar Skeleton */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-4 w-10" />
            </div>
            <Skeleton className="h-2 w-full" />
          </div>
        </div>
      </div>
    </Card>
  );
});

